import { render } from "./ExpanderMarquee.vue?vue&type=template&id=a03f3baa&scoped=true"
import script from "./ExpanderMarquee.vue?vue&type=script&lang=js"
export * from "./ExpanderMarquee.vue?vue&type=script&lang=js"

import "./ExpanderMarquee.vue?vue&type=style&index=0&id=a03f3baa&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a03f3baa"]])

export default __exports__